import { useContext, useState } from "react";
import IOAbstract, { EditContext, type IOProps } from "./io-abstract";

export default function IOString(
  props: IOProps<string> & {
    validation?: (value: string | undefined) => string;
  }
) {
  const editContext = useContext(EditContext);
  const [currentError, setCurrentError] = useState<string | React.ReactNode>(
    ""
  );

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as string;

    // Custom validation
    const customMessage = props.validation?.(value) ?? "";
    event.target.setCustomValidity(customMessage);

    // validationMessage will hold customMessage
    setCurrentError(event.target.validationMessage);

    props.onChange?.(value);
  };

  return (
    <IOAbstract<string>
      currentError={currentError}
      editContext={editContext}
      type="string"
      renderOutput={<div>{props.value}</div>}
      renderInput={(uuid) => (
        <input
          id={uuid}
          className="form-control"
          name={props.name}
          defaultValue={props.value ?? ""}
          onChange={onChange}
          required={props.required}
          {...props.htmlProps}
        />
      )}
      {...props}
    />
  );
}
